export const ru = {
    no_participants: 'Нет участников',
    go_to_staff: 'Перейти на Стафф',
};
